module.exports = __webpack_public_path__ + "models/scene4adults.38902bf.txt";